/*
 * iam's one-time sign-in link (`sign_in_url`), returned right after an email
 * signup's code (or a new invitee's join) is accepted. Following it lets
 * Keycloak open a real session with no screen, so every app — console,
 * git.dodil.io, the partner site, signup itself — recognises the person the
 * normal way. Followed only if it is Keycloak's own address.
 */
export function keycloakLink(url: unknown, keycloakBase = import.meta.env.VITE_KC_URL as string | undefined): string | undefined {
    if (typeof url !== 'string' || !url || !keycloakBase) return undefined;
    try {
        const u = new URL(url);
        const kc = new URL(keycloakBase);
        const local = ['localhost', '127.0.0.1', '[::1]'].includes(u.hostname);
        return u.origin === kc.origin && (u.protocol === 'https:' || local) ? u.toString() : undefined;
    } catch {
        return undefined;
    }
}
